<!-- <div> -->
<!-- <i class="mdi mdi-clipboard-account"  title = {{textoPopover}} titlePosition="{{placement}}" ></i> -->
<plex-icon name="clipboard-account" [title]="textoPopover" [titlePosition]="placement"></plex-icon>
<!-- </div> -->